/* eslint-disable no-else-return */
import React, { Fragment, useEffect } from 'react'
import { useLocation, NavLink } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import UserDetails from './UserDetails'
import { LilStar, IconBack } from '../helpers/Star'
import Timeline from './Timeline'
import Certificate from './Certificate'
import { ShareButton } from './ShareButton'

const UserPage = (props) => {
  // console.log(`props:`)
  // console.log(props)

  const location = useLocation().pathname

  let profile
  let tweets
  let cdn
  let profileString
  let shareImageUrl

  const connectBool = props.connectBool
  if (connectBool !== true) {
    const username = props.match.params.username
    tweets = props.tweets
    const user = tweets.filter((tweeter) => {
      if (tweeter.username === username) {
        return tweeter
      }
      return null
    })
    profile = user[0]

    // eslint-disable-next-line no-useless-escape
    profileString = profile.username.toLowerCase().replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '')
    cdn = 'https://ixi4jeb43ehhpm46.s3.us-east-1.amazonaws.com/twitterverse/social/'

    shareImageUrl = `${cdn}${profileString}.png`
  } else {
    profile = props.tweets.user
    tweets = props.tweets.top_tweets
  }

  if (!connectBool && (props.match === undefined || profile === undefined)) {
    return <LilStar />
  } else if (connectBool === true) {
    useEffect(() => {
      // load at top
      const startPointX = 0
      const startPointY = 0
      window.scroll(startPointX, startPointY)
    }, [])
    return (
      <div>
        <div className="single">
          <NavLink to="/welcome" className="back-button">
            <IconBack />
          </NavLink>
          <UserDetails profile={profile} connectBool={connectBool} />
          <Timeline tweets={tweets} connectBool={connectBool} />
          <ShareButton />
        </div>
      </div>
    )
  } else {
    useEffect(() => {
      // load at top
      const startPointX = 0
      const startPointY = 0
      window.scroll(startPointX, startPointY)
    }, [])
    tweets = profile
    const single = tweets.response.data
    let cert
    if (tweets.cert) {
      cert = tweets.cert
    }

    return (
      <Fragment>
        <Helmet>
          <title>{`Twitterverse — @${profile.username}`}</title>
          <meta property="og:type" content="website" />
          <meta property="og:url" content={`https://twitterverse.spacecadet.ventures${location}`} />
          <meta property="og:title" content={`@${profile.username} on The Twitterverse`} />
          <meta
            property="og:description"
            content="Join Spacecadet in celebrating 15 years of the little blue bird by exploring the best tweets of all-time, from the all-stars of the platform."
          />
          <meta property="og:image" content={`${shareImageUrl}`} />
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={`https://twitterverse.spacecadet.ventures${location}`} />
          <meta property="twitter:title" content={`@${profile.username} on The Twitterverse`} />
          <meta
            property="twitter:description"
            content="Join Spacecadet in celebrating 15 years of the little blue bird by exploring the best tweets of all-time, from the all-stars of the platform."
          />
          <meta property="twitter:image" content={`${shareImageUrl}`} />
        </Helmet>
        <div className="single" id="single">
          <NavLink to="/welcome" className="back-button">
            <IconBack />
          </NavLink>
          <UserDetails profile={profile} />
          <Timeline tweets={tweets.response.data.top_tweets} />
          <ShareButton />
        </div>
        {!!tweets.cert && (
          <div className="certificate_container">
            <Certificate {...tweets} tweets={single} cert={cert} />
          </div>
        )}
      </Fragment>
    )
  }
}

export default UserPage
